<template>
  <v-dialog max-width="500px" v-model="inDialog" @click:outside="onClickOutside" persistent>
    <v-card>
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
                $t(formCreateName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Tên lớp')"
                  v-model.trim="item.className"
                  name="className"
                  v-validate="'required'"
                  maxLength="250"
                  :error-messages="errors.first('Tên lớp')"
                  :data-vv-as="$t('Tên lớp')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="babiProLevel"
                  :label="$t('Level')"
                  v-model="item.level"
                  name="level"
                  item-value="value"
                  v-validate="'required'"
                  item-text="text"
                  :data-vv-as="$t('Level')"
                  :error-messages="errors.first('Level')"
              />
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="degreeProLevel"
                  :label="$t('Trình độ')"
                  v-model="item.degree"
                  name="degree"
                  v-validate="'required'"
                  item-value="value"
                  item-text="text"
                  :data-vv-as="$t('Trình độ')"
                  :error-messages="errors.first('Trình độ')"
              />
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="teachersBabiPro"
                  :label="$t('Loại giáo viên')"
                  v-model="item.teachersType"
                  name="teachersType"
                  v-validate="'required'"
                  item-value="value"
                  item-text="text"
                  :data-vv-as="$t('Loại giáo viên')"
                  :error-messages="errors.first('Loại giáo viên')"
                  v-on:change="teachersChange2(item.teachersType)"

              />
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="programs"
                  :label="$t('Khung thời gian học')"
                  v-model="item.programTimeId"
                  name="programTimeId"
                  item-value="programTimeId"
                  item-text="programTimeName"
                  v-validate="'required'"
                  :data-vv-as="$t('Level')"
                  :error-messages="errors.first('Khung thời gian học')"
                  :disabled="item.teachersType  ? false : true"
                  v-on:change="teachersChange2(item.teachersType)"
              />
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="packages"
                  :label="$t('Gói học')"
                  v-model="item.packageId"
                  name="packageId"
                  item-value="packageId"
                  item-text="packageName"
                  v-validate="'required'"
                  :data-vv-as="$t('Level')"
                  :error-messages="errors.first('Gói học')"
                  :disabled="item.teachersType  ? false : true"
                  v-on:change="teachersChange2(item.teachersType)"
              />
            </v-flex>

            <v-flex xs12>
              <i-datepicker
                  :label="$t('Ngày bắt đầu')"
                  v-model="item.startDate"
                  v-validate="'required'"
                  :defaultValue="item.startDate ? true : false"
                  :error-messages="errors.first('Ngày bắt đầu')"
                  @clearText="clearDropDate"
                  clearable
                  :disabled="item.teachersType  ? false : true"
                  v-on:change="teachersChange2((item.teachersType))"
              />
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="teachersB1"
                  :label="$t('Giáo viên buổi 1')"
                  v-model="item.teachersId1"
                  name="teachersId1"
                  item-value="id"
                  item-text="nameTeacher"
                  v-validate="'required'"
                  :data-vv-as="$t('Level')"
                  :disabled="item.teachersType  ? false : true"
                  :error-messages="errors.first('Giáo viên buổi 1')"
              />
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="teachersB2"
                  :label="$t('Giáo viên buổi 2')"
                  v-model="item.teachersId2"
                  name="teachersId2"
                  item-value="id"
                  item-text="nameTeacher"
                  v-validate="'required'"
                  :data-vv-as="$t('Level')"
                  :error-messages="errors.first('Giáo viên buổi 2')"
                  :disabled="item.teachersType  ? false : true"
              />
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="teachersB3"
                  :label="$t('Giáo viên buổi 3')"
                  v-model="item.teachersId3"
                  name="teachersId3"
                  item-value="id"
                  item-text="nameTeacher"
                  :data-vv-as="$t('Level')"
                  :disabled="item.packageId == 1  ? false : true"
              />
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="teachersTa"
                  :label="$t('Giáo viên TA')"
                  v-model="item.teachersIdTa"
                  name="teachersIdTa"
                  item-value="id"
                  item-text="nameTeacher"
                  :data-vv-as="$t('Level')"
                  :error-messages="errors.first('Giáo viên TA')"
              />
            </v-flex>
            <!--            <v-flex xs12>
                          <v-select
                              :items="areaStatus"
                              :label="$t('Trạng thái')"
                              v-model="item.isActive"
                              name="isActive"
                              item-value="value"
                              item-text="text"
                              :data-vv-as="$t('Trạng thái')"
                              :error-messages="errors.first('isActive')"
                          />
                        </v-flex>-->
          </v-layout>
        </v-card-text>
      </v-form>
      <div style="text-align: right">
        <v-btn color="primary" @click="onSave">
          <v-icon dark left>save</v-icon>
          {{ $t("lang.common.save") }}
        </v-btn>
        <v-btn color="error" @click="onCancel">
          <v-icon dark left>cancel</v-icon>
          {{ $t("lang.common.cancel") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {message} from "../../services";
import axios from "axios";
import {areaContants, cateContants} from "@/constants";
import moment from "moment/moment";

export default {
  name: "material-type-group-create",
  components: {message, axios},
  props: {
    propsItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    cDialog: {
      type: Boolean,
      default: false,
    },
    formCreateName: {
      type: String,
      default: '',
    },
    programs: {
      type: Array,
      default: [],
    },
    packages: {
      type: Array,
      default: [],
    },
    teachersB1: {
      type: Array,
      default: [],
    },
    teachersTa: {
      type: Array,
      default: [],
    },
    teachersB2: {
      type: Array,
      default: [],
    },
    teachersB3: {
      type: Array,
      default: [],
    },
    clearable: {
      type: Boolean,
      default: false
    },
  },
  data: () => {
    return {
      areaStatus: cateContants.classIsActive,
      babiProLevel: cateContants.levelBabiPro,
      degreeProLevel: cateContants.degreeBabiPro,
      teachersBabiPro: cateContants.teachersBabiPro,
      item: {
        className: "",
        level: "",
        degree: "",
        programTimeId: "",
        packageId: "",
        teachersId1: "",
        teachersIdTa: "",
        teachersId2: "",
        teachersId3: "",
        teachersType: "",
        startDate: "",
        isActive: 1,
      },
      inDialog: false,
    };
  },
  watch: {
    propsItem: {
      handler(value) {
        //console.log(value);
        if (value !== null) {
          this.item = {
            classIdPro: value.classIdPro,
            className: value.className
                ? value.className
                : "",
            programTimeId: value.programTimeId
                ? value.programTimeId
                : "",
            degree: value.degree
                ? value.degree
                : "",
            packageId: value.packageId
                ? value.packageId
                : "",
            level: value.level
                ? value.level
                : "",
            startDate: value.startDate
                ? value.startDate
                : "",
            teachersId1: value.teachersId1
                ? value.teachersId1
                : "",
            teachersIdTa: value.teachersIdTa
                ? value.teachersIdTa
                : "",
            teachersId2: value.teachersId2
                ? value.teachersId2
                : "",
            teachersId3: value.teachersId3
                ? value.teachersId3
                : "",
            teachersType: value.teachersType
                ? value.teachersType
                : "",
            status: value.status ? value.status : 1,
            isActive: value.isActive ? value.isActive : 1,
          };
        } else {
          this.resetFrom();
        }
      },
      deep: true,
    },
    cDialog(value) {
      this.inDialog = value;
    },
    inDialog(value) {
      if (!value) {
        this.$emit("closeCreateDialog", "");
      }
    },
  },
  methods: {
    resetFrom: function () {
      this.item = {
        className: "",
        programTimeId: "",
        level: "",
        degree: "",
        packageId: "",
        teachersId1: "",
        teachersIdTa: "",
        teachersId2: "",
        teachersId3: "",
        startDate: "",
        teachersType: "",
        isActive: 1,
      };
    },
    checkMinDate(minDate = moment()) {
      if (minDate == '' || minDate == null) minDate = moment();
      let minDate_tmp = moment(String(minDate));
      let today = moment();
      // if (minDate_tmp <= today) {
      //     minDate = moment().format('YYYY-MM-DD');
      // } else {
      minDate = minDate_tmp.format('YYYY-MM-DD');
      // }
      return minDate;
    },
    clearDropDate() {
      this.item.startDate = '';
    },
    teachersChangeEdit1(type) {
      // teachersB1
      axios.post(
          process.env.VUE_APP_API_URL + "/kidClassBabiPro/listAllTeacherEdit1/" + type, this.item
      )
          .then(
              (data) => {
                if (data.length > 0) {
                  this.teachersB1 = data;
                }
              }
          );
    },
    teachersChangeEdit2(type) {
      // teachersB1
      axios.post(
          process.env.VUE_APP_API_URL + "/kidClassBabiPro/listAllTeacherEdit2/" + type, this.item
      )
          .then(
              (data) => {
                if (data.length > 0) {
                  this.teachersB2 = data;
                }
              }
          );
    },


    teachersChange1(type) {
      // teachersB1
      axios.post(
          process.env.VUE_APP_API_URL + "/kidClassBabiPro/listAllTeacher/" + type, this.item
      )
          .then(
              (data) => {
                if (data.length > 0) {
                  this.teachersB1 = data;
                }
              }
          );
    },

    teachersChange2(type) {
      // teachersB2
      axios.post(
          process.env.VUE_APP_API_URL + "/kidClassBabiPro/listAllTeacher/" + type, this.item
      )
          .then(
              (data) => {
                if (data.length > 0) {
                  this.teachersB2 = new Array();
                  this.teachersB1 = new Array();
                  this.teachersTa = new Array();
                  data.forEach(item => {
                    console.info("item.type " + item.type);
                    console.info("type " + type);
                    if (item.type == type) {
                      this.teachersB2.push(item);
                    }
                    if (item.type == 3) {
                      this.teachersB3.push(item);
                    }
                    if ((item.type == 1)) {
                      this.teachersB1.push(item);
                      this.teachersTa.push(item);
                    }
                  });
                }
              }
          );

    },
    onCancel: function () {
      this.$emit("closeCreateDialog", "");
    },
    onSave: function () {
      // console.log(this.item);
      this.$validator.validate().then((valid) => {
        if (!valid) {
          message.error(this.$t("lang.common.validate_fail"));
          return;
        }
        axios
            .post(
                process.env.VUE_APP_API_URL +
                "/kidClassBabiPro/save",
                this.item
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                    this.resetFrom();
                    this.onCancel();
                  } else {
                    let msg = data.description;
                    if (data.description === 'lang.category.duplicateCode') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    } else if (data.description === 'lang.category.duplicateName') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    }
                    message.error(this.$t(msg));
                  }
                },
                (error) => {
                  console.log(error);
                }
            );
      });
    },
    onClickOutside: function () {
      alert(1);
    },

  },
  created() {
    // Program
    axios.post(
        process.env.VUE_APP_API_URL + "/kidProgramTime/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                this.programs = data;
              }
            }
        );

    // kidPackage
    axios.post(
        process.env.VUE_APP_API_URL + "/kidPackage/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                this.packages = data;
              }
            }
        );

   /* axios.post(
        process.env.VUE_APP_API_URL + "/kidTeacher/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                  if (data[i]["type"] == 1) {
                    this.teachersB1.push(data[i]);
                  }
                  this.teachersB2.push(data[i]);

                }
              }
            }
        );*/
  },
};
</script>
